import type { FC } from "react";
import { Container, ContentContainer } from "@src/core/styles";
import { Title, Description, CardBlock, Questions } from "./components";
import { ContentWrapper } from "../home-page/dashboard.styles";

export const PricePage: FC = () => {
  return (
    <Container>
      <Title />
      <ContentContainer>
        <ContentWrapper>
          <Description />
          <CardBlock />
          <Questions />
        </ContentWrapper>
      </ContentContainer>
    </Container>
  );
};
